if (!customElements.get('collection-upsell')) {
  customElements.define(
    'collection-upsell',
    class CollectionUpsell extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderComponents = this.querySelectorAll('.product-upsell__slider');

        this.overallPrice = this.querySelector('.product-upsell__overall-price');
        this.compareAtPrice = this.querySelector('.product-upsell__compare-at-price');
        this.price = this.querySelector('.product-upsell__price');

        this.cards = this.querySelectorAll('card-upsell');
        this.cards.forEach((card) => {
          card.addEventListener('click', this.onCardClick.bind(this, card));
        });

        this.stickyCompareAtPrice = document.querySelector('.sticky-atc__compare-at-price');
        this.stickyPrice = document.querySelector('.sticky-atc__price');

        this.apolloSection = document.querySelector(`#Apollo-${this.dataset.sectionId}`);
        this.hasApolloUpsell = !!this.apolloSection?.getSelectedVariantId();

        subscribe(PUB_SUB_EVENTS.variantChange, ({ html }) => {
          const newUpsell = html.getElementById(`Upsell-${this.dataset.sectionId}`);
          this.dataset.defaultCompareAtPrice = newUpsell.dataset.defaultCompareAtPrice;
          this.dataset.defaultPrice = newUpsell.dataset.defaultPrice;

          this.cards.forEach((card) => card.updateOptions(html));

          this.stickyCompareAtPrice = document.querySelector('.sticky-atc__compare-at-price');
          this.stickyPrice = document.querySelector('.sticky-atc__price');

          const card = this.getSelectedCard();
          if (card) {
            this.stickyCompareAtPrice.textContent = card.getCompareAtPrice();
            this.stickyPrice.textContent = card.getPrice();

            this.compareAtPrice.textContent = card.getCompareAtPrice();
            this.price.textContent = card.getPrice();
            this.overallPrice.classList.remove('hidden');
          } else {
            this.stickyCompareAtPrice.textContent = this.hasApolloUpsell ? this.dataset.compareAtPriceApolloBox : this.dataset.defaultCompareAtPrice;
            this.stickyPrice.textContent = this.hasApolloUpsell ? this.dataset.priceApolloBox : this.dataset.defaultPrice;

            this.overallPrice.classList.add('hidden');
          }
        });
      }

      updateApolloBox() {
        this.hasApolloUpsell = !!this.apolloSection?.getSelectedVariantId();
        this.cards.forEach((card) => card.updateApolloBox());

        const card = this.getSelectedCard();
        if (card) {
          this.stickyCompareAtPrice.textContent = card.getCompareAtPrice();
          this.stickyPrice.textContent = card.getPrice();

          this.compareAtPrice.textContent = card.getCompareAtPrice();
          this.price.textContent = card.getPrice();
          this.overallPrice.classList.remove('hidden');
        } else {
          this.stickyCompareAtPrice.textContent = this.hasApolloUpsell ? this.dataset.compareAtPriceApolloBox : this.dataset.defaultCompareAtPrice;
          this.stickyPrice.textContent = this.hasApolloUpsell ? this.dataset.priceApolloBox : this.dataset.defaultPrice;

          this.overallPrice.classList.add('hidden');
        }
      }

      onOptionChange(card) {
        this.stickyCompareAtPrice.textContent = card.getCompareAtPrice();
        this.stickyPrice.textContent = card.getPrice();

        this.compareAtPrice.textContent = card.getCompareAtPrice();
        this.price.textContent = card.getPrice();
        this.overallPrice.classList.remove('hidden');
      }

      onCardClick(card) {
        if (card.classList.contains('upsell-card-wrapper--active')) {
          card.classList.remove('upsell-card-wrapper--active');
          this.selectedCard = null;

          this.stickyCompareAtPrice.textContent = this.hasApolloUpsell ? this.dataset.compareAtPriceApolloBox : this.dataset.defaultCompareAtPrice;
          this.stickyPrice.textContent = this.hasApolloUpsell ? this.dataset.priceApolloBox : this.dataset.defaultPrice;

          this.overallPrice.classList.add('hidden');
        } else {
          this.cards.forEach((card) => card.classList.remove('upsell-card-wrapper--active'));
          card.setOptionChangeCallback(this.onOptionChange.bind(this, card));
          card.classList.add('upsell-card-wrapper--active');
          this.selectedCard = card;

          let compareAtPrice = card.getCompareAtPrice();
          let price = card.getPrice();

          if (compareAtPrice === null) {
            compareAtPrice = formatPrice(card.jsonDataParsed[0].compare_at_price);
          }
          if (price === null) {
            price = formatPrice(card.jsonDataParsed[0].price);
          }

          this.stickyCompareAtPrice.textContent = compareAtPrice;
          this.stickyPrice.textContent = price;

          this.compareAtPrice.textContent = compareAtPrice;
          this.price.textContent = price;
          this.overallPrice.classList.remove('hidden');
        }
      }

      getSelectedCard() {
        return this.selectedCard ?? null;
      }

      getSelectedVariantId() {
        return this.selectedCard?.getSelectedVariantId() ?? null;
      }
    }
  );
}
